import React from "react";
import { Routes, Route } from "react-router-dom";  
import Layout from "../layouts/Layout";
import Home from "../pages/Home";
import Contact from "../pages/Contact";
import Pricing from "../pages/Pricing";
import About from '../pages/About';
import BlogPost from '../pages/BlogPost';
import Checkout from "../pages/Checkout";
import Blog from "../pages/Blog";
import Faq from "../pages/Faq";


const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                                <Route path="/faq" element={<Faq />} />


        <Route path="/checkout" element={<Checkout />} />
        <Route path="/blog/:slug" element={<BlogPost />} />

      </Route>
    </Routes>
  );
};

export default AppRoutes;